import Text from 'components/Text/Text';
import React, { useCallback } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { TTypeOfCreateGameModalWindow } from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import style from './CreateDeveloperBtn.module.scss';

interface ICreateDeveloperBtn {
	changeTypeOfModalWindow: (value: TTypeOfCreateGameModalWindow) => void;
}

const CreateDeveloperBtn: React.FC<ICreateDeveloperBtn> = ({ changeTypeOfModalWindow }) => {
	const handleCreate = useCallback(() => {
		changeTypeOfModalWindow('createDeveloper');
	}, [changeTypeOfModalWindow]);

	return (
		<Button
			className={style.btn}
			data-test="CreateDeveloperBtn"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}
			onClick={handleCreate}>
			<Text translationNameSpace="form" translationKey="createDeveloperButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(CreateDeveloperBtn);
